import * as React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';

const ModalLabelLeft = styled(Box)(({ theme }) => ({
  width: '410px',
  height: '510px',
  marginTop: '-16px',
  marginLeft: '-12px',

  [theme.breakpoints.down('md')]: {
    width: '0px',
    height: '0px',
    marginTop: '0px',
    marginLeft: '0px',
  },
}));

const LabelText = styled('ul')(({ theme }) => ({
  width: '148px',
  height: '144px',
  listStyle: 'none',
  marginTop: '60px',
  marginLeft: '40px',
  fontFamily: 'Caveat',
  fontSize: '24px',
  lineHeight: '30px',

  [theme.breakpoints.down('md')]: {
    width: '0px',
    height: '0px',
    marginTop: '0px',
    marginLeft: '0px',
    fontSize: '0px',
    lineHeight: '0px',
  },
}));

const CoffeeTopiaText = styled('div')(({ theme }) => ({
  width: '120px',
  height: '37px',
  marginTop: '26px',
  marginLeft: '50px',
  fontFamily: 'Caveat',
  fontWeight: '700',
  fontSize: '24px',
  lineHeight: '30px',
  color: '#000000',

  [theme.breakpoints.down('md')]: {
    width: '0px',
    height: '0px',
    marginTop: '0px',
    marginLeft: '0px',
    fontSize: '0px',
    lineHeight: '0px',
    fontWeight: '0',
  },
}));

export default function AuthenticationLeftText() {
  return (
    <ModalLabelLeft>
      <LabelText>
        <li>Find</li>
        <li>Share</li>
        <li>Like</li>
        <li>everything</li>
        <li>about coffee</li>
      </LabelText>
      <CoffeeTopiaText>@ Coffeetopia</CoffeeTopiaText>
    </ModalLabelLeft>
  );
}
